import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BootstrapMembersInformationComponent } from './components/bootstrap-members-information/bootstrap-members-information.component';

const routes: Routes = [
  {path:'', component:BootstrapMembersInformationComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MembersInformationRoutingModule { }
